export default {
  methods: {
    formatToCurrency(amount) {
      return Number(amount).toLocaleString('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
    },
  },
};
